import { NgModule, Injector } from '@angular/core';
import { InjectorComponent } from './injector.component';

@NgModule({
    declarations: [InjectorComponent],
    exports: [InjectorComponent]
})
export class InjectorModule {
    constructor(_injector: Injector) {
        AppInjector = _injector;
    }
}

export let AppInjector: Injector;
